import BasePropertyTabView from 'properties/BasePropertyTabView';
import propertyViewMapService from 'PropertyViewMapService.js';
import contentTemplate from 'properties/tab-access-view.ejs';
import formModel from 'formModel.js'
import listService from 'ListService';

class TabAccessView extends BasePropertyTabView {

    initialize( opts ) {
        this.options = opts || {};

        this.tagName = 'div';
        this.id = '#access';
        this.factoryKey = opts.factoryKey;
        this.template = contentTemplate;

        super.initialize(opts);

        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }
        return this;
    }

    render(opts) {
        this.factoryKey = this.model.attributes.factoryKey;
        if (opts && opts.factoryKey) {
            this.factoryKey = opts.factoryKey;
        }

        this.clearPropertyViews();
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        // Render Property Views
        var views = [];
        this.layout = formModel.get('currentDevice');
        this.multipleSelected = (opts && opts.multipleSelected); 
        if (this.layout === 'deviceDesktop') {
            // Render Property Views
            if (this.multipleSelected) {                
                views = propertyViewMapService.getMultipleSelectedAccessViews();               
                this.model = listService.combineSelectedModels();
                this.model.set('factoryKey', '', {silent: true});
                this.model.set('displayControlName', '', {silent: true});
                this.model.set('controlName', '', {silent: true});
            } else {
                views = propertyViewMapService.getAccessViews(this.factoryKey);
            }
            this.model.set('displayMode', '', {silent: true});
        }

        //const views = propertyViewMapService.getAccessViews(this.factoryKey);
        this.renderPropertyViews(views, this.model);

        return this;
    }
}

export default TabAccessView;